module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "titlepage"
    }
  }, [_c('h1', {
    staticClass: "booktitle"
  }, [_vm._v("HANDMADE WEDDINGS")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("MORE THAN 50 CRAFTS TO STYLE and PERSONALIZE YOUR BIG DAY")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("EUNICE MOYLE, SABRINA MOYLE, AND SHANA FAUST")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Photographs by")]), _vm._v(" JOSEPH DE LEO")]), _vm._v(" "), _c('p', {
    staticClass: "publogo"
  }, [_c('img', {
    attrs: {
      "alt": "publisher logo",
      "src": "images/logo.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "image2"
    }
  }, [_c('p', {
    staticClass: "center image_vert"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('img', {
    attrs: {
      "alt": "Handmade Weddings",
      "height": "80%",
      "src": "images/image-2.jpg",
      "width": "auto"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e87753f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003titlepage.vue
// module id = 60
// module chunks = 0